export default {
  sm: `
    DATA CENTER GAK global provides
    a network that links infrastructure 
    bases in 10 major regions around 
    the world, and is expanding cloud 
    service regions where you can 
    access the same services anytime and 
    anywhere based on the global
    infrastructure of NAVER and LINE.
  `,
  md: `
    DATA CENTER GAK global provides a network that links infrastructure bases in 10 major regions around the world, and is expanding cloud service regions where you can access the same services anytime and anywhere based on the global infrastructure of NAVER and LINE.
  `,
  lg: `
    DATA CENTER GAK global provides a network that links infrastructure bases in 
    10 major regions around the world, and is expanding cloud service regions where you can access the same services anytime and anywhere based on the global infrastructure of NAVER and LINE.
  `,
  xl: `
    DATA CENTER GAK global provides a network that links infrastructure bases in 
    10 major regions around the world, and is expanding cloud service regions 
    where you can access the same services anytime and anywhere based on the global
    infrastructure of NAVER and LINE.
  `,
};
